import { createEffect } from "solid-js";
import { fetchScript } from "~/utils/fetchScript";

interface CommentsProps {
  identifier: string;
  title: string;
  url: string;
}

let isDisqusLoaded = false;

export default function Comments(props: CommentsProps) {
  createEffect(() => {
    if (!import.meta.env.VITE_DISQUS_ID) {
      return;
    }

    if (isDisqusLoaded) {
      setTimeout(() => {
        (globalThis as any).DISQUS?.reset({
          reload: true,
          config: function () {
            this.page.identifier = props.identifier;
            this.page.title = props.title.slice(0, 200);
            this.page.url = props.url;
          },
        });
      }, 500);
      return;
    }

    (globalThis as any).disqus_shortname = import.meta.env.VITE_DISQUS_ID;
    (globalThis as any).disqus_config = function () {
      this.page.identifier = props.identifier;
      this.page.title = props.title.slice(0, 200);
      this.page.url = props.url;
    };

    setTimeout(() => {
      fetchScript(
        `https://${import.meta.env.VITE_DISQUS_ID}.disqus.com/embed.js`,
      );
    }, 500);
    isDisqusLoaded = true;
  });

  return (
    <>
      <noscript>Eita! Você precisa ativar o JavaScript para comentar.</noscript>
      <div id="disqus_thread" />
    </>
  );
}
